<template>
    <v-form ref="form_inclusion_accesorio" :lazy-validation="true">
        <v-container fluid grid-list-sm>
            <v-row dense>
                <v-col cols="12" sm="12">
                    <ModalFormDatosAccesorioComponent :objModal="objModalAccesorio"
                        :parametrosAccesorios="_.get(parametros,'accesorios',{})"
                        :porc_casco_permitir_valor_accesorio_adicional="parametros.porc_casco_permitir_valor_accesorio_adicional_wizard"
                        :valorCasco="_.toNumber(_.get(objForModal,'valorVehiculo',0))" />
                </v-col>
            </v-row>

            <v-row dense>
                <template v-for="item in _.orderBy(objAccesorios,['orden'],['asc'])">
                    <v-col cols="12" sm="3" :key="item.id_accesorio">
                        <div class="text-center" style="position: relative; z-index: 100;">
                            <v-btn class="mx-2" x-small fab dark
                                :disabled="item.disabled"
                                :style='item.check ? "background-color: #4caf50 !important;border-color: #4caf50 !important;" : "background-color: #EE4637 !important;border-color: #EE4637 !important;"'
                                @click="addAccesorio(item);">
                                <v-icon dark v-if="item.check">check</v-icon>
                                <v-icon dark v-else>add</v-icon>
                            </v-btn>
                        </div>
                        <div class="text-center" style="position: relative;margin-top: -35px">
                            <v-img :src="item.icono" contain height="200" max-height="200" />
                        </div>
                        <div class="text-center">
                            <span class="caption" v-html="item.nombre_accesorio"></span>
                        </div>
                    </v-col>
                </template>
            </v-row>

        </v-container>
    </v-form>
</template>

<script>
    export default {
        components: {
            ModalFormDatosAccesorioComponent: () => import('./ModalFormDatosAccesorioComponent.vue')
        },
        props:{
            load:{type: Boolean, default: false},
            objModal:{type: Object, default: {}},
            listGeneral:{type: Object, default: {}},
            parametros:{type: Object, default: {}},
        },
        // props: ['load', 'objModal', 'listGeneral', 'parametros'],
        inject: ['apiSend'],
        data: () => ({
                objForModal: {},
                objFormFactura: {},
                objAccesorios: {},
                objModalAccesorio: {
                    abrirModal: false
                },
        }),
        watch: {
            load() {
                if (this.load && _.size(this.listGeneral.listAccesorios) == 0)
                    this.cargaGeneral();
            }
        },
        methods: {
            cargaGeneral() {
                this.objForModal = _.clone(_.omit(this.objModal, ['abrirModal']));
                this.objFormFactura = _.clone(this.objForModal);
                this.onListarAccesorios('L')
                    .catch((e) => {
                        mensajesAlerta(e, 'E');
                    });
            },
            onListarAccesorios(event) {
                if (!_.isUndefined(event)) {
                    this.$set(this, 'objAccesorios', {});
                    var listOrden = [
                        {'id':this.parametros.accesorios.id_accesorio_radio_wizard,'orden':0},
                        {'id':this.parametros.accesorios.id_accesorio_aros_wizard,'orden':1},
                        {'id':this.parametros.accesorios.id_accesorio_llantas_wizard,'orden':2},
                        {'id':this.parametros.accesorios.id_accesorio_otros_wizard,'orden':3},
                    ];

                    var lista = [];
                    var o = {
                        opcion:'VALIDAR_ACCESORIO_INCLUSION',
                        idCertificado: _.get(this.objForModal, 'idCertificado', null),
                        idPoliza: _.get(this.objForModal, 'idPoliza', null),
                        idEstado: _.get(this.parametros, 'id_estado_default', null)
                    }

                    return this.apiSend('administrador/inclusion-accesorio/listar',o)
                               .then((r) => {
                                    if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                        lista = _.cloneDeep(r.data.data);
                                        var objeto = {
                                            opcion: 'LISTAR_X_PRODUCTO_WIZARD',
                                            idProducto: _.get(this.objForModal, 'idProducto', null),
                                            idEstado: _.get(this.parametros, 'id_estado_default', null)
                                        };

                                    return this.apiSend('administrador/accesorio/listar', objeto);
                                })
                                .then((r)=>{
                                    if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                    if (_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                                        var l = _.cloneDeep(r.data.data);

                                        _.map(l,(v,k) => {
                                            var dd = _.find(lista,{'idAccesorio':v.id_accesorio});
                                            v.disabled = !_.isUndefined(dd) ? true : false;
                                            v.icono = `data:image/svg+xml;base64,${v.icono}`;
                                            v.check = false;
                                            v.color = 'red';
                                            v.orden = _.get(_.find(listOrden,{'id':parseInt(v.id_accesorio)}),'orden',null);
                                            var k = _.get(_.find(listOrden,{'id':parseInt(v.id_accesorio)}),'id',null);

                                            var ob = _.find(l,{'id_accesorio':_.toString(k)});
                                            this.$set(this.objAccesorios, _.camelCase(_.get(ob, 'nombre_accesorio')),ob);
                                        });
                                        this.$set(this.objForModal, 'abrirModal', _.get(this.objModal, 'abrirModal', false));
                                    return r;
                                });
                }
            },
            addAccesorio(objeto) {
                try {
                    if(objeto.disabled) throw 'Ya cuenta con una inclusión para este accesorio.';
                        var index = _.findIndex(this.listGeneral.listAccesorios, (v) => {
                            return parseInt(v.id_accesorio) == parseInt(objeto.id_accesorio)
                        });
                        if (index >= 0)
                            this.$set(this, 'objModalAccesorio', _.merge({}, {
                                size: '40%',
                                abrirModal: true,
                                titulo: objeto.nombre_accesorio
                            }, objeto, this.listGeneral.listAccesorios[index]));
                        else
                            this.$set(this, 'objModalAccesorio', _.merge({}, {
                                size: '40%',
                                abrirModal: true,
                                titulo: objeto.nombre_accesorio
                            }, objeto));
                } catch (error) {
                    mensajesAlerta(error,'I');
                }
            },
            addListAccesorio(objeto, remove) {
                try {
                    return new Promise((resolve,reject) =>{
                        var band = false;
                        var chilCompoImpuesto = this.$parent.$parent.$parent.$parent.$children[0].$children[1];

                        //Revisar indicador 
                        this.addListData(objeto, remove);
                        if (parseInt(objeto.genera_solicitud) > 0) {
                            this.objModalAccesorio = { abrirModal: false };
                        } else {
                            chilCompoImpuesto.onListarImpuestos('L')
                                .then((r) => {
                                    if (_.size(_.get(r, ['data', 'data'], 0)) == 0) { band = true; throw _.get(r, ['data','mensaje'], 'Ocurrio un error al leer a información.') };
                                    return chilCompoImpuesto.onListarDerechoEmision('L');
                                })
                                .then((r) => {
                                    if (_.size(_.get(r, ['data', 'data'], 0)) == 0) { band = true; throw _.get(r, ['data','mensaje'], 'Ocurrio un error al leer a información.') };
                                    this.objModalAccesorio = { abrirModal: false };
                                })
                                .catch((e) => {
                                    mensajesAlerta(e, 'E');
                                });
                        }

                        if(!band)
                            resolve(band);
                        else
                            reject(band);
                    });
                } catch (error) {
                    mensajesAlerta(error, 'E');
                }
            },
            addListData(objeto, remove) {
                var check = false;
                if (!remove) {
                    check = true;
                    if (objeto.index) {
                        var index = _.findIndex(this.listGeneral.listAccesorios, (v) => {
                            return parseInt(v.index) == parseInt(objeto.index)
                        });

                        this.listGeneral.listAccesorios[index] = _.merge({}, _.omit(objeto, ['icono', 'color', 'size',
                            'titulo', 'abrirModal'
                        ]), {
                            'check': check
                        });
                    } else
                        this.listGeneral.listAccesorios.push(_.merge({}, {
                            index: _.uniqueId()
                        }, _.omit(objeto, ['icono', 'color', 'size', 'titulo', 'abrirModal']), {
                            'check': check
                        }));
                } else
                    this.listGeneral.listAccesorios = _.remove(_.clone(this.listGeneral.listAccesorios), (v) => {
                        return parseInt(v.index) != parseInt(objeto.index)
                    });


                this.objAccesorios = _.map(_.clone(this.objAccesorios), (v, k) => {
                    if (parseInt(v.id_accesorio) == parseInt(objeto.id_accesorio))
                        v.check = check;
                    return v;
                });
            },
        },
        provide() {
            return {
                addListAccesorio: this.addListAccesorio
            }
        }
    }
</script>
<style>
    .v-btn--floating .v-btn__content {
        height: 70% !important;
    }
</style>